import React, { useState, Fragment } from 'react';
import { Plus, Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useNavigate, useParams } from 'react-router-dom';
const courseNames: Record<string, string> = {
  '1': 'Ethics & The Rules (with NAR Code of Ethics)',
  '2': 'NAR Code of Ethics (NO CE CREDIT)',
  '3': 'Deeds, Fires & Water: Be Prepared',
  '5': 'Are They Represented?',
  '6': 'Mastering Agency Agreements',
  '8': 'A Letter From ADRE',
  '9': "Don't Lose Your License",
  '10': 'BMC #1 AZ Residential-Statutes and Rules',
  '11': 'BMC #2 AZ Residential-Broker Policies',
  '12': 'BMC #3 AZ Residential-Broker Supervision',
  '13': 'BMC #3B Property Management',
  '14': 'What Goes Wrong In Contracts',
  '15': 'Avoid The Oops: Contract Smarts for Agents',
  '17': 'No Secrets',
  '18': 'The Bottom Line of Disclosure',
  '19': 'Your Clients Are Not Mushrooms',
  '20': 'They Are A Protected Class',
  '21': "Fair Housing In Today's World",
  '23': 'Accidental Property Management',
  '24': 'Follow All The Laws'
};
export function CourseSectionsByCourse() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const courseName = courseNames[id ?? ''] ?? 'Course';
  const sections = [1, 2, 3, 4, 5].map(n => ({
    id: n,
    section: `Section ${n}`
  }));
  return <div className="space-y-4" data-id="element-330">
      <div className="flex items-center justify-between" data-id="element-331">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-332">Course Sections</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/courses')} data-id="element-333">
          ← Back to Courses
        </Button>
      </div>

      <div data-id="element-334">
        <Button size="sm" variant="secondary" className="gap-1.5 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/sections/add')} data-id="element-335">
          <Plus className="h-3.5 w-3.5 text-green-600" data-id="element-336" />
          Add
        </Button>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-337">
        <div className="overflow-x-auto" data-id="element-338">
          <table className="w-full text-sm text-left" data-id="element-339">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-340">
              <tr data-id="element-341">
                <th className="px-4 py-3 border-r border-slate-700" data-id="element-342">Course</th>
                <th className="px-4 py-3 border-r border-slate-700 text-center w-28" data-id="element-343">
                  Section
                </th>
                <th className="px-4 py-3 border-r border-slate-700 text-center w-32" data-id="element-344">
                  Questions
                </th>
                <th className="px-4 py-3 text-center w-40" data-id="element-345">
                  <div data-id="element-346">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-347">
                    View | Edit | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-348">
              {sections.map(row => <tr key={row.id} className="hover:bg-slate-50" data-id="element-349">
                  <td className="px-4 py-2.5 border-r border-slate-200" data-id="element-350">
                    <button className="text-blue-600 hover:underline text-left" onClick={() => navigate(`/courses/view/${id}`)} data-id="element-351">
                      {courseName}
                    </button>
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-center" data-id="element-352">
                    <button className="text-blue-600 hover:underline" onClick={() => navigate(`/sections/view/${row.id}`)} data-id="element-353">
                      {row.section}
                    </button>
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-center" data-id="element-354">
                    <button className="text-blue-600 hover:underline" onClick={() => navigate('/questions')} data-id="element-355">
                      View Questions
                    </button>
                  </td>
                  <td className="px-4 py-2.5 text-center" data-id="element-356">
                    <div className="flex items-center justify-center gap-2" data-id="element-357">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/sections/view/${row.id}`)} data-id="element-358">
                        <Eye className="h-4 w-4" data-id="element-359" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/sections/edit/${row.id}`)} data-id="element-360">
                        <Edit className="h-4 w-4" data-id="element-361" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-362">
                        <Trash2 className="h-4 w-4" data-id="element-363" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="text-sm text-blue-600 flex items-center gap-1" data-id="element-364">
        <button className="hover:underline" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))} data-id="element-365">
          &lt;&lt; previous
        </button>
        <span className="text-slate-400" data-id="element-366">|</span>
        {[1, 2, 3].map((n, i) => <Fragment key={n} data-id="element-367">
            {i > 0 && <span className="text-slate-400" data-id="element-368">|</span>}
            <button onClick={() => setCurrentPage(n)} className={`hover:underline ${currentPage === n ? 'text-slate-900 font-medium' : ''}`} data-id="element-369">
              {n}
            </button>
          </Fragment>)}
        <span className="text-slate-400" data-id="element-370">|</span>
        <button className="hover:underline" onClick={() => setCurrentPage(Math.min(3, currentPage + 1))} data-id="element-371">
          next &gt;&gt;
        </button>
      </div>
    </div>;
}